'use strict';
import {
    f7
} from "framework7-svelte";
import { sendLineNotifyMessage } from "./LineNotify.js";
import { format } from "./i18n.js";

export function capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
}

export function getLanguageFromLocale(locale) {
    let index = locale.indexOf("-");
    return index != -1 ? locale.substring(0, index) : locale;
}

export function checkImage(url) {
    return new Promise((resolve, reject) => {
        var imageData = new Image();
        imageData.onload = function () {
            resolve(true);
        };
        imageData.onerror = function () {
            resolve(false);
        };
        imageData.src = url;
    });
}

export function b64toBlob(b64Data, contentType = '', sliceSize = 1024) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

export function showErrorNotifyDialog(title, text, user, error) {
    f7.dialog.create({
        title: title, text: text, buttons: [
            {
                text: format('orderNew.reportError.title'),
                bold: true,
                color: "red",
                onClick: function () {
                    sendLineNotifyMessage({ message: "An error occurred when user '" + user + "' tried to make a new order: \n\n" + error });
                    f7.toast
                        .create({
                            text: format('orderNew.reportError.success'),
                            closeTimeout: 6000
                        })
                        .open();
                }
            },
            {
                text: format('base.close'),
            }
        ],
    }).open();
}